import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables';

import {
  CardButtons,
  ActionButtonList
} from '@/modules/common/components/cards/CardButtons';
import { PortabilityRequestsData } from '@/modules/home/services/bff';

interface Props {
  data: PortabilityRequestsData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PortabilityRequestsCard',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: PortabilityRequestsData;
}



const router = useRouter();

const button: ActionButtonList[] = [
  {
    label: props.data.buttonLabel,
    action: 'onClick'
  }
];

const handleClick = () => {
  router.push({ name: 'portabilityRequests' });
};

return { __sfc: true,props, router, button, handleClick, CardButtons }
}

})